import { defineComponent as _defineComponent } from 'vue'
import { getStore } from "@/store/getStore";
import { getRolesLabels } from "../../services/roles/utils";
import BadgesList from "@/components/ui/BadgesList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProfile',
  setup(__props) {

const profile = getStore().getters.getAuthentificationProfile;

return { __sfc: true,profile, getRolesLabels, BadgesList }
}

})